import { render, staticRenderFns } from "./VsToaster.vue?vue&type=template&id=13ac0e80&lang=pug&"
import script from "./VsToaster.vue?vue&type=script&lang=js&"
export * from "./VsToaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ac0e80')) {
      api.createRecord('13ac0e80', component.options)
    } else {
      api.reload('13ac0e80', component.options)
    }
    module.hot.accept("./VsToaster.vue?vue&type=template&id=13ac0e80&lang=pug&", function () {
      api.rerender('13ac0e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsToaster.vue"
export default component.exports